import { IBaseInfo, ISignetInfo } from '../routes/seal';

type Idata = {
  baseInfo: IBaseInfo;
  signetInfo: ISignetInfo;
};

export const quitData: Idata = {
  baseInfo: {
    width: 1100,
    height: 600,
    marginTop: 56,
    padding: 100,
    backgroundColor: '#fff',
    title: '离职证明',
    titleFontFamily: 'fangsong',
    titleFontSize: 30,
    titleMarginBottom: 32,
    titleFontColor: '#000',
    content: `    姓名：_________，男，身份证号码：_____________________，自_______年____月____日入职我公司担任___________部__________一职，至_______年____月____日因_____________原因申请离职，在此_________年间工作良好无不良表现。
    经公司慎重思考准予离职，已办理交接手续。_________因未签订相关保密协议，遵从择业自由。
    特此证明。
`,
    contentFontFamily: 'fangsong',
    contentFontColor: '#333',
    contentFontSize: 24,
    contentLineHeight: 44,
    rbContent1: '单位名称 (盖章)',
    rbContent2: '2022 年 6 月 30 日',
    rbContentFontFamily: 'fangsong',
    rbContentFontSize: 24,
    rbContentFontColor: '#333',
    rbContentLineHeight: 36,
    rbRight: 100,
    rbBottom: 70,
  },
  signetInfo: {
    size: 186,
    offsetX: 114,
    offsetY: 15,
    borderColor: '#EE0000',
    contentSize: 24,
    content: '某某某科技有限公司',
    contentColor: '#EE0000',
    contentFamily: 'fangsong',
    describe: '',
    describeColor: '#EE0000',
    describeSize: 18,
    describeFamily: 'fangsong',
    rotate: -15,
    opacity: 90,
    abrasion: 60,
  },
};

export const workData: Idata = {
  baseInfo: {
    width: 680,
    height: 820,
    marginTop: 60,
    padding: 70,
    title: '工作证明',
    titleFontSize: 26,
    titleMarginBottom: 38,
    content: `    兹证明______同志（身份证号码：_____________）为我司员工，任职_______部门，职务为________，累计满___年。
    特此证明。`,
    contentFontSize: 20,
    contentLineHeight: 38,
    rbContentFontSize: 18,
    rbContentLineHeight: 30,
    rbRight: 100,
    rbBottom: 390,
    backgroundColor: '#fff',
    titleFontFamily: 'fangsong',
    titleFontColor: '#000',
    contentFontFamily: 'fangsong',
    contentFontColor: '#333',
    rbContent1: '单位名称 (盖章)',
    rbContent2: '2022 年 6 月 30 日',
    rbContentFontFamily: 'fangsong',
    rbContentFontColor: '#333',
  },
  signetInfo: {
    size: 166,
    offsetX: 98,
    contentSize: 22,
    content: '某某某科技有限公司',
    offsetY: 334,
    borderColor: '#EE0000',
    contentColor: '#EE0000',
    contentFamily: 'fangsong',
    describe: '',
    describeColor: '#EE0000',
    describeSize: 18,
    describeFamily: 'fangsong',
    rotate: -15,
    opacity: 90,
    abrasion: 60,
  },
};

export const incomeData: Idata = {
  baseInfo: {
    width: 680,
    height: 820,
    marginTop: 60,
    padding: 70,
    title: '收入证明',
    titleFontSize: 26,
    titleMarginBottom: 38,
    content: `    兹证明______是我单位职工，性别____，身份证号码____________，在_____部门任______职务。月收入______元，一年总收入约为______
    特此证明！

    本证明仅用于证明我单位职工的工作及在我单位的工资收入，不作为我单位对该员工任何形势的担保文件。`,
    contentFontSize: 20,
    contentLineHeight: 38,
    rbContentFontSize: 18,
    rbContentLineHeight: 30,
    rbRight: 100,
    rbBottom: 194,
    backgroundColor: '#fff',
    titleFontFamily: 'fangsong',
    titleFontColor: '#000',
    contentFontFamily: 'fangsong',
    contentFontColor: '#333',
    rbContent1: '单位名称 (盖章)',
    rbContent2: '2022 年 6 月 30 日',
    rbContentFontFamily: 'fangsong',
    rbContentFontColor: '#333',
  },
  signetInfo: {
    size: 166,
    offsetX: 98,
    contentSize: 22,
    content: '某某某科技有限公司',
    offsetY: 140,
    borderColor: '#EE0000',
    contentColor: '#EE0000',
    contentFamily: 'fangsong',
    describe: '',
    describeColor: '#EE0000',
    describeSize: 18,
    describeFamily: 'fangsong',
    rotate: -15,
    opacity: 90,
    abrasion: 60,
  },
};

export const practiceData: Idata = {
  baseInfo: {
    width: 680,
    height: 820,
    marginTop: 60,
    padding: 70,
    title: '实习证明',
    titleFontSize: 26,
    titleMarginBottom: 38,
    content: `兹有________学校______专业______同学于____年____月____日至____年____月____日在______公司实习，该同学的实习职位是_______________。

    该学生实习期间工作认真，在工作中遇到不懂的地方，能够 虚心向富有经验的前辈请教，善于思考，举一反三。对于别人提 出的 工作建议，虚心听取。能够将在学校所学的知识灵活应用到具体的工作中去，保质保量完成工作任务。同吋，该学生严格遵 守我单位的各项规章制度。实习期间，服从实习安排，按吋完成 实习任务。与公司同事关系融洽，集体意识强，领导和共事员工都对该学生的表现予以充分肯定。

    特此证明。`,
    contentFontSize: 20,
    contentLineHeight: 38,
    rbContentFontSize: 18,
    rbContentLineHeight: 30,
    rbRight: 100,
    rbBottom: 90,
    backgroundColor: '#fff',
    titleFontFamily: 'fangsong',
    titleFontColor: '#000',
    contentFontFamily: 'fangsong',
    contentFontColor: '#333',
    rbContent1: '单位名称 (盖章)',
    rbContent2: '2022 年 6 月 30 日',
    rbContentFontFamily: 'fangsong',
    rbContentFontColor: '#333',
  },
  signetInfo: {
    size: 166,
    offsetX: 98,
    contentSize: 22,
    content: '某某某科技有限公司',
    offsetY: 36,
    borderColor: '#EE0000',
    contentColor: '#EE0000',
    contentFamily: 'fangsong',
    describe: '',
    describeColor: '#EE0000',
    describeSize: 18,
    describeFamily: 'fangsong',
    rotate: -15,
    opacity: 90,
    abrasion: 60,
  },
};

export const commonData: Idata = {
  baseInfo: {
    width: 1100,
    height: 600,
    marginTop: 56,
    padding: 100,
    backgroundColor: '#fff',
    title: '通用模板标题',
    titleFontFamily: 'fangsong',
    titleFontSize: 30,
    titleMarginBottom: 32,
    titleFontColor: '#000',
    content: `    姓名：_________，男，身份证号码：_____________________，自_______年____月____日，XXXXXXXX，XXXXXXX，XXXXXXX，XXXXXXX，
    内容自定义，请输入您需要的内容
    特此证明。
`,
    contentFontFamily: 'fangsong',
    contentFontColor: '#333',
    contentFontSize: 24,
    contentLineHeight: 44,
    rbContent1: '通用模板(盖章)',
    rbContent2: '2022 年 6 月 30 日',
    rbContentFontFamily: 'fangsong',
    rbContentFontSize: 24,
    rbContentFontColor: '#333',
    rbContentLineHeight: 36,
    rbRight: 100,
    rbBottom: 70,
  },
  signetInfo: {
    size: 186,
    offsetX: 114,
    offsetY: 15,
    borderColor: '#EE0000',
    contentSize: 22,
    content: '输入盖章的单位',
    contentColor: '#EE0000',
    contentFamily: 'fangsong',
    describe: '描述',
    describeColor: '#EE0000',
    describeSize: 18,
    describeFamily: 'fangsong',
    rotate: -15,
    opacity: 90,
    abrasion: 60,
  },
};
